import React, {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import '../stylesheets/ProductsFilter.css'

// Card UI
import {Card, CardActions, CardContent, Button, Typography} from '@material-ui/core'

// Date Picker
import 'date-fns'
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';

// Country Select
import {FormControl, Select, Input, InputLabel, MenuItem} from '@material-ui/core'

// Error Popup
import CircularProgress from '@material-ui/core/CircularProgress';

/**
 * Must import CSS file, see productFilter.css for an example
 */


/**
 * Props:
 * 
 * handleSelectChange={this.handleSelectChange.bind(this)} // Required
 * handleDateChange={this.handleDateChange.bind(this)}  // Required
 * handleSubmit={this.handleSubmit.bind(this)} // Required
 * StartDate={this.state.StartDate} // Required
 * EndDate={this.state.EndDate} // Required
 * city={this.state.city} // Required ""
 * country={this.props.match.params.country} // Required ""
 * countryDisabled={true} // Required True or False
 * allCities={this.state.allCities} // Required
 * allCountries={this.state.allCountries}
 * loading={this.state.loading}
 */
class FilterCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      none: undefined
    }

  }

  render() {
    return (
      <Card style={{backgroundColor: '#f7f7f7'}} className="cardStyle">

      <div style={{display: 'flex', justifyContent: 'center', marginTop: 10}}>
        <Typography className="cardHeader" >Filter Products</Typography>
      </div>

      <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
        <div style={{flex: 0.5}}>
          <CardContent>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                name="StartDate"
                margin="normal"
                label="Start Date"
                value={this.props.StartDate}
                onChange={this.props.handleDateChange.bind(null, "StartDate")}
                // onChange={this.handleDateChange.bind(null, "StartDate")}
              />

            </MuiPickersUtilsProvider>
          </CardContent>
        </div>
        <div style={{flex: 0.5}}>
          <CardContent>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <DatePicker
                name="EndDate"
                margin="normal"
                label="End Date"
                value={this.props.EndDate}
                onChange={this.props.handleDateChange.bind(null, "EndDate")}
                // onChange={this.handleDateChange.bind(null, "EndDate")}
              />

            </MuiPickersUtilsProvider>
          </CardContent>
        </div>
      </div>

    <div style={{display: 'flex', flexDirection: 'row', flex: 1}}>
      <div style={{flex: 0.5}}>
        <CardContent>
          <FormControl style={selectStyles.formControl}>
            <InputLabel shrink htmlFor="city-label-placeholder">
              City
            </InputLabel>
            <Select
              displayEmpty
              value={this.props.city}
              onChange={this.props.handleSelectChange}
              input={<Input name="city" id="city-label-placeholder" />}
              name="city"
            >
            <MenuItem value=""><em>Select</em></MenuItem>
            {
              this.props.allCities ? 
              this.props.allCities.map(item => (
                <MenuItem key={item.city} value={item.city}>{item.city}</MenuItem>
              )) 
              : null
            }
            </Select>
          </FormControl>
        </CardContent>
      </div>

      <div style={{flex: 0.5}}>
        <CardContent>
          <FormControl style={selectStyles.formControl}>
            <InputLabel shrink htmlFor="country-label-placeholder">
              Country
            </InputLabel>
            <Select
              displayEmpty
              disabled={this.props.countryDisabled}
              value={this.props.country}
              input={<Input name="country" id="country-label-placeholder" />}
              name="country"
            >
            {
              this.props.allCountries ?
              <MenuItem value=""><em>Select</em></MenuItem> 
              :
              <MenuItem value={this.props.country}><em>{this.props.country}</em></MenuItem>
            }
            {
              this.props.allCountries ?
              this.props.allCountries.map(item => (
                <MenuItem key={item.country} value={item.country}>{item.country}</MenuItem>
              )) 
              : null
            }
            </Select>
          </FormControl>
        </CardContent>
      </div>

    </div>


      <div style={{display: 'flex', justifyContent: 'center', marginTop: 5}}>
        <CardActions>
            <Button onClick={this.props.handleSubmit} variant="contained" style={{color: 'white',backgroundColor: "#33a371"}}>Search</Button>
            {
              this.props.loading ? <CircularProgress size={25} color="secondary" /> : null
            }
        </CardActions>
      </div>
    </Card>
    )
  }
}

const styles = {
  card: {
    // minWidth: (window.innerWidth <= 760) ? 300 : 400,
    // minHeight: 300
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
};

const selectStyles = {
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
  },
  selectEmpty: {
    // marginTop: theme.spacing.unit * 2,
  },
};

export default withStyles(styles)(FilterCard)